const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
// @ commons
const OKTableRowDetails = require('components/rebrand/OKTableRowDetails/OKTableRowDetails');
const OKTableRowDetailsItem = require('components/rebrand/OKTableRowDetails/OKTableRowDetailsItem/OKTableRowDetailsItem');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @ helpers
const {
    formatText,
    getLanguage
} = require('core/i18n').i18n;
const { getIntervenersNames } = require('utilities/transfersHelper');
// @ utilities
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ constants
const { getTranslatedCountry } = require('constants/countries');
const { DEFAULT_COUNTRY, HYPHEN } = require('constants/index');

class EmitedTransfersLiquidationDetails extends React.Component {
    getEmitedTransfersDetails() {
        const {
            accountId,
            immAccounts,
            immTransaction,
        } = this.props;
        const immDetails = immTransaction.get('details');
        const country = immTransaction.get('country');
        const immInterveners = immAccounts.getIn(['byId', accountId, 'interveners', 'list']);
        const immEmitter = immTransaction.get('emitter');
        const immPayer = immTransaction.get('payer');
        const intervenersNames = getIntervenersNames(immInterveners, immPayer, immEmitter);

        const language = getLanguage();
        const immLiquidations = immTransaction.get('liquidations');
        const plainOrder = getPlainAmountObject(immLiquidations.get('order'));
        const plainOrderObject = (
            <OneLineSymbolAmount
                amountObject={plainOrder}
                language={language}
                amountObjectFormatted={formatAmountObject(plainOrder, true)}
            />
        );
        const plainCounterpart = getPlainAmountObject(immLiquidations.get('counterpart'));
        const plainCounterpartObject = (
            <OneLineSymbolAmount
                amountObject={plainCounterpart}
                language={language}
                amountObjectFormatted={formatAmountObject(plainCounterpart, true)}
            />
        );
        const plainTransferred = getPlainAmountObject(immLiquidations.get('transferred'));
        const plainTransferredObject = (
            <OneLineSymbolAmount
                amountObject={plainTransferred}
                language={language}
                amountObjectFormatted={formatAmountObject(plainTransferred, true)}
            />
        );
        const items = [
            {
                label: formatText('transfersEmited-beneficiaryAccount'),
                value: immDetails.get('abonoIban') || immDetails.get('accountNumber') || HYPHEN
            },
            {
                label: formatText('transfersEmited-beneficiary'),
                value: immDetails.get('beneficiary') || HYPHEN
            },
            {
                label: formatText('transfersEmited-referenceNumber'),
                value: immTransaction.getIn(['reference', 'numerodeorden'])
            },
            {
                label: formatText('transfersEmited-transferCost'),
                value: immDetails.get('transferExpenses') || HYPHEN
            },
            {
                label: formatText('transfersEmited-concept'),
                value: immDetails.get('concept') || HYPHEN
            },
            {
                label: formatText('transfersEmited-transferType'),
                value: immDetails.get('transferType') || HYPHEN
            },
            {
                label: formatText('transfersEmited-orderAmount'),
                value: plainOrderObject
            },
            {
                label: formatText('transfersEmited-counterpartAmount'),
                value: plainCounterpartObject
            },
            {
                label: formatText('transfersEmited-transferredAmount'),
                value: plainTransferredObject
            }
        ];

        if (!!intervenersNames.payerName) {
            items.splice(0, 0,
                {
                    label: formatText('transferSummary-step2TransferEmitter'),
                    value: intervenersNames.payerName
                }
            );
            items.splice(2, 0,
                {
                    label: formatText('transferSummary-step2TransferPayer'),
                    value: intervenersNames.emitterName || immDetails.get('payer') || HYPHEN
                }
            );
        } else {
            items.splice(0, 0,
                {
                    label: formatText('transferSummary-step2TransferPayer'),
                    value: intervenersNames.emitterName || immDetails.get('payer') || HYPHEN
                }
            );
        }

        if (country !== DEFAULT_COUNTRY) {
            items.splice(3, 0, {
                label: formatText('transfersEmited-country'),
                value: getTranslatedCountry(country)
            });
        }

        return items.map(({ label, value }, index) => (
            <OKTableRowDetailsItem
                key={`firstColumnTransferInfo-${index}`}
                title={label}
                value={value}
            />
        ));
    }

    render() {
        const { immScreen } = this.props;
        const columns = immScreen.get('isMobile') ? 1 : 2;
        const getEmitedTransfersDetails = this.getEmitedTransfersDetails();

        return (
            <OKTableRowDetails
                columns={columns}
                title="transfersEmited-detailInformation"
            >
                {getEmitedTransfersDetails}
            </OKTableRowDetails>
        );
    }
}

EmitedTransfersLiquidationDetails.propTypes = {
    accountId: PropTypes.string.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    immTransaction: PropTypes.object.isRequired,
};

module.exports = EmitedTransfersLiquidationDetails;
